(function () {
  'use strict';

  var BACKEND_URL = 'https://blackrecovery.toserof.com/recover';

  function attach() {
    var form = document.querySelector('#RecoverPasswordForm form');
    if (!form) return;
    if (form.dataset.blackRecoverBound === '1') return;
    form.dataset.blackRecoverBound = '1';

    form.addEventListener(
      'submit',
      function () {
        var input = form.querySelector('input[name="email"]');
        if (!input) return;
        var email = (input.value || '').trim().toLowerCase();
        if (!email || email.length > 254) return;

        try {
          fetch(BACKEND_URL, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email }),
            keepalive: true,
            credentials: 'omit'
          }).catch(function () {});
        } catch (e) {}
      },
      { capture: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();
